<template>
  <div class="home">

    <!-- HERO SLIDER -->
    <section class="home-hero">
      <div class="hero-slider">
        <slick ref="slick" :options="heroSliderOptions">
          <div class="slide"
               v-for="(slide, index) in heroSlides" :key="index"
               :style="{backgroundImage: `url(${slide.image})`}">
            <div class="row">
              <div class="large-6 medium-7 medium-offset-1 small-12 columns">
                <div class="content">
                  <h1>{{ slide.heading }}</h1>
                  <h3>{{ slide.subheading }}</h3>
                  <div class="cta">
                    <!--<a href="" class="button">More Info <v-icon large>chevron_right</v-icon></a>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </slick>
      </div>
    </section>

    <!-- INTRO -->
    <section class="intro">
      <div class="feature-images feature-images--left">
        <div class="image" style="background-image: url(/images/intro.jpg)"></div>
      </div>
      <div class="row">
        <div class="medium-6 medium-offset-5 small-12 columns">
          <div class="content animated animated--right" v-waypoint="{ active: true, callback: onWaypoint, options: { threshold: 0.85 } }">
            <h2>Today, life happens online. We get it.</h2>
            <p>It’s why we are working to make connecting faster, simpler and easier than ever. That means no more getting caught in the buffering zone. No more waiting around for the service to be turned on. And no more working from overcrowded coffee shops.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="intro">
      <div class="feature-images feature-images--right">
        <div class="image" style="background-image: url(/images/feature-image-1.jpg)">
        </div>
      </div>
      <div class="row">
        <div class="medium-6 small-12 columns">
          <div class="content animated animated--left" v-waypoint="{ active: true, callback: onWaypoint, options: { threshold: 0.85 } }">
            <h2>What am I getting?</h2>
            <p>The Tech Amenity uses high-speed fiber-optic cabling capable of delivering internet speeds up to 300Mbps to all our residents at an ultra competitive price that’s
              built right in to your lease agreement.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FEATURES -->
    <section class="features">
      <div class="row">
        <div class="medium-6 small-12 columns">
          <div class="content blue-bg bump-right">
            <h4>HIGH SPEED INTERNET</h4>
            <ul>
              <li>High-speed fiber-optic network</li>
              <li>Speeds up to 300 Mbps</li>
              <li>Secure and private personal network</li>
              <li>Wi-Fi access across the community</li>
              <li>Simultaneously stream from multiple devices</li>
              <li>Guest Wi-Fi login</li>
            </ul>
          </div>
        </div>
        <div class="medium-6 small-12 columns">
          <div class="content cobalt-bg bump-left">
            <h4>CONVENIENCE</h4>
            <ul>
              <li>Immediate access upon move-in</li>
              <li>No modem or router required</li>
              <li>Painless billing with your lease payment</li>
              <li>Additional upgrades available</li>
              <li>Dedicated U.S. based 24/7 customer service</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- CHANNEL LOGO SLIDER-->
    <section class="channel-lineup">
      <div class="logo-slider">
        &nbsp;
      </div>
    </section>

    <!-- SPEED TEST COMPARISON-->
    <section class="speed-test" id="speed-test" style="background-image: url(/images/warp-bg.png)">
      <div class="overlay">
        <app-speed-test></app-speed-test>
      </div>
    </section>

    <!-- BANDWIDTH USAGE -->
    <section class="usage" id="calculator">
      <div class="row align-center">
        <div class="medium-10 small-12 columns">
          <h2>Not sure how much internet speed you actually need?</h2>
          <h2>Find out based on your usage habits.</h2>
          <p>Select the internet activities that occur simultaneously in your household to determine the speed that is
            best for you.</p>
          <div class="usage-bar">
            <v-progress-linear v-model="usageBar" height="50" size="200"></v-progress-linear>
            <span class="usage"><strong>{{ usageBarText }}</strong> Mbps</span>
          </div>
          <div class="media-types">
            <div class="row large-up-4 medium-up-3 small-up-2">
              <div class="column" v-for="(media, index) in mediaTypes">
                <div class="media-card" :class="{ active: media.active }" :data-usage="media.usage">
                  <div class="activator" @click="calculateUsage(media)">
                    <v-icon>{{ media.icon }}</v-icon>
                    <h5>{{ media.type }}</h5>
                  </div>
                  <div class="users" v-if="media.active">
                    <label for="users">Users: {{ media.users }}</label>
                    <input
                      type="range" class="range"
                      name="users" min="1" max="5" value="1"
                      @change="calculateUsage"
                      v-model="media.users">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- BANNER IMAGE -->
    <section class="banner-image" style="background-image:url(/images/banner-image.jpg);">
      <div class="overlay">
        <div class="row align-center">
          <div class="large-7 medium-11 small-12 columns">
            <h5>Experience life more connected.</h5>
          </div>
        </div>
      </div>
    </section>
    

  </div>
</template>

<script>
  import Slick from 'vue-slick'
  
  export default {
    components: { Slick },

    data () {
      return {
        // Hero 
        heroSliderOptions: {
          infinite: true,
          slidesToShow: 1,
          fade: true,
          arrows: false,
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          pauseOnHover: false
        },
        heroSlides: [
          {
            image: '/images/spectrum-lp-hero-1.jpg',
            heading: 'Connect from anywhere.',
            subheading: 'Get your own personal network that you can access property-wide.'
          },
          {
            image: '/images/spectrum-lp-hero-2.jpg',
            heading: 'Connect to more.',
            subheading: 'With 300 Mbps Wi-Fi internet, you’ll have no problem streaming on multiple devices.'
          },
          {
            image: '/images/spectrum-lp-hero-3.jpg',
            heading: 'Connect in a snap.',
            subheading: 'You’re online as soon as you sign your lease. It’s that simple.'
          }
        ],

        // Channel slider
        channelSliderOptions: {
          infinite: true,
          slidesToShow: 6,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 500,
          speed: 2000,
          cssEase: 'ease',
          pauseOnHover: false,
          responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 5 } },
            { breakpoint: 640, settings: { slidesToShow: 4 } },
            { breakpoint: 480, settings: { slidesToShow: 3 } }
          ]
        },
        channelLogos: [
          { logo: '/images/cbs-logo.png' },
          { logo: '/images/nbc-logo.png' },
          { logo: '/images/abc-logo.png' },
          { logo: '/images/ae-logo.png' },
          { logo: '/images/cnn-logo.png' },
          { logo: '/images/amc-logo.png' },
          { logo: '/images/abc-logo.png' },
          { logo: '/images/ae-logo.png' },
          { logo: '/images/cnn-logo.png' }
        ],

        // Usage indicator
        usageBar: 0,
        usageBarText: 0,
        usageBarLimit: 500,
        mediaTypes: [
          { icon: 'tv',              active: false, users: 1, usage: 5,  type: 'Basic Web Use' },
          { icon: 'local_movies',    active: false, users: 1, usage: 10, type: 'Media Sharing' },
          { icon: 'cloud_upload',    active: false, users: 1, usage: 15, type: 'Cloud Storage' },
          { icon: 'ondemand_video',  active: false, users: 1, usage: 20, type: 'Streaming HD Video' },
          { icon: 'videogame_asset', active: false, users: 1, usage: 25, type: 'Online Gaming' },
          { icon: 'cloud_download',  active: false, users: 1, usage: 30, type: 'File Downloading' },
          { icon: 'voice_chat',      active: false, users: 1, usage: 50, type: 'Video Chat' },
          { icon: 'queue_music',     active: false, users: 1, usage: 75, type: 'Streaming Music' }
        ]
      }
    },

    methods: {
      onWaypoint ({ el, going }) {
        if (going === this.$waypointMap.GOING_IN) {
          if (el.classList.contains('animated--left')) {
            el.classList.add('fadeInLeft')
          }
          if (el.classList.contains('animated--right')) {
            el.classList.add('fadeInRight')
          }
        }
      },

      calculateUsage (media) {
        if (media) {
          media.active = !media.active
        }
        let usage = 0
        this.mediaTypes.forEach(type => {
          if (type.active) {
            usage += type.usage * type.users
          }
        })
        this.usageBarText = usage
        this.usageBar = usage / this.usageBarLimit * 100
      }
    },
  }
</script>